import React, { useState, useMemo } from 'react';
import styled from 'styled-components';

import Dropdown from 'antd/es/dropdown';
import Badge from 'antd/es/badge';

import useNotifications from 'hooks/useNotifications';

import Button from 'components/Button';
import { Link } from 'components/Text';
import NotificationsList from './NotificationsList';

const NotificationDropdown = ({
  title = 'Alerts',
  iconName = 'bell',
  nrOfItems = 5,
  showAll = true,
  showAllLink = '/alerts',
  showOnly = [],
  hideOnly = [],
}) => {
  const [visible, setVisible] = useState(false);
  const notifications = useNotifications({ fetch: 'active',autoFetch: true, refreshInterval: 180000 });

  const notificationsData = useMemo(() => {
    let notificationsData = notifications.state.active.filter(notification => {
      return (showOnly.length && showOnly.includes(notification.notification_type))
        || (hideOnly.length && !hideOnly.includes(notification.notification_type))
    });

    return notificationsData;
  }, [notifications.state.active, hideOnly, showOnly]);

  const nrOfUnreads = notificationsData.filter(n => n.is_read === 0).length;

  return (
    <NotificationDropdownWrapper>
      <StyledDropdown
        overlay={
          <NotificationsList
            header={title}
            data={notificationsData.slice(0, nrOfItems)}
            isLoading={notifications.state.isLoading}
            onItemClicked={item => {
              setVisible(false);
              if (!item.is_read) {
                notifications.actions.markAsRead(item);
              }
            }}
            footer={showAll ? (
              <Link
                to={showAllLink}
                onClick={() => setVisible(false)}
              >
                Show all
              </Link>
            ) : null}
          />
        }
        overlayStyle={{
          width: '450px',
          boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
          borderRadius: '4px',
        }}
        placement="bottomRight"
        trigger="click"
        visible={visible}
        onVisibleChange={() => setVisible(!visible)}
      >
        <Badge count={nrOfUnreads} offset={[-4, 8]} style={countBadgeStyles}>
          <Button
            shape="circle"
            icon={{ name: iconName, size: 20, color: '#A4B0BA' }}
          />
        </Badge>
      </StyledDropdown>
    </NotificationDropdownWrapper>
  );
};

const NotificationDropdownWrapper = styled.div`
  & button {
    min-width: 38px;
    width: 38px;
    height: 38px;
    padding: 0;

    & > span {
      margin-top: 4px;
    }
  }
`;

const StyledDropdown = styled(Dropdown)`
  & .notification-wrapper {
    padding: 12px 8px;
    border: 1px solid red;
  }
`;

const countBadgeStyles = {
  minWidth: '16px',
  height: '16px',
  padding: 0,
  fontSize: '11px',
  lineHeight: '16px',
  backgroundColor: '#F5222D',
};

export default NotificationDropdown;
